import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Motion, spring } from 'react-motion';

import { withStyles } from '@material-ui/core/styles';

import ProjectCard from '../admin/Project/ProjectCard'
import selectClientProjects from '../../store/selectors/clientProjects';

const styles = theme => ({
  root: {
  },
});

const ClientProjects = ({classes, clientProjects}) => {
  return (
    <div className={classes.root}>
      {clientProjects.map((project, id) => {
        return (
          <div key={id}>
            <Motion defaultStyle={{x: -20, y: -20, opacity: 0}}
                    style={{
                      x: spring(0),
                      y: spring(0),
                      opacity: spring(1, { stiffness: 90, damping: 10})
                    }}>
              {(style) => (
                <div  style={{
                        transform: `translate(${style.x}px, ${style.y}px)`,
                        opacity: style.opacity
                      }}>
                  <ProjectCard
                    project={project} />
                </div>
              )}
            </Motion>
          </div>
        );
      })}
    </div>
  );
}


const mapStateToProps = (state) => {
    if (state.adminState.client != null) {
      return { clientProjects: selectClientProjects(state.projectsState, state.adminState.client) };
    } else {
      return { clientProjects: [] };
    }
};

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(ClientProjects);



// WEBPACK FOOTER //
// ./src/components/clients/ClientProjects.jsx